export const primaryPrefix = 'COMMON_PAGING_';
export const secondaryPrefix = 'COMMON_SECONDARY_PAGING_';

export const primaryStateName = 'paging';
export const secondaryStateName = 'secondaryPaging';



// WEBPACK FOOTER //
// ./src/state/paging/constants.js